<div class="wrap d-flex">
    <div class="col-md-8 nopad">
    <div class="QFocuss cQfocuss">
        <div class="">
            <div class="col-md-12 p-0">
                <div class="sync-details">
                    <ul id="sync1" class="list-unstyled">
                        <owl-carousel-o [options]="customOptions" #owlCar1>
                            <ng-container *ngFor="let hotel of hotels; let i = index;">
                                <ng-template carouselSlide [id]="i">
                                    <li class="item">
                                        <a href="javascript:void(0);">
                                            <img class="img-responsive" [src]="hotel" height="550"
                                                onError="this.src='https://q-cf.bstatic.com/images/hotel/max1024x768/232/232825737.jpg'"
                                                (click)="morePhotos();" data-toggle="modal" data-target="#seemore_photos">
                                        </a>
                                    </li>
                                </ng-template>
                            </ng-container>
                        </owl-carousel-o>
                    </ul>
                </div>
            </div>
            <div class="col-md-12 nopad">
                <ul id="sync2" class="list-unstyled">
                    <owl-carousel-o [options]="customOptions2">
                        <ng-container *ngFor="let hotel of hotels; let i = index;">
                            <ng-template carouselSlide [id]="i">
                                <li class="item">
                                    <a href="javascript:void(0);">
                                        <img class="img-responsive" width="100" height="150"
                                            (mouseenter)="handleCarouselImage(i)" [src]="hotel"
                                            onError="this.src='https://q-cf.bstatic.com/images/hotel/max1024x768/232/232825737.jpg'">
                                    </a>
                                </li>
                            </ng-template>
                        </ng-container>
                    </owl-carousel-o>
                </ul>
            </div>
        </div>
    </div>
    </div>
    <div class="col-md-4 pr-0 mobile_padlft">

        <div class="wid30 bdrtop">
            <div class="d-flex">
               <div class="wid56n2">
                  <p class="toptl">Standard Double Room</p>
                  <p class="sbtoptl">{{travellerAdult}} Adult | {{travellerChild}} Child  | {{hotel.searchRequest.NoOfRooms}} x Room</p>
                  <!-- <div class="cantxt mflex">
                  <img src="assets/images/check-circle.svg" class="tickmrk">
                  <span>Free Cancellation</span>
                  </div> -->
               </div>
               <div class="wid44n2 t_right">
                
                  <!-- <input type="hidden" id="hdnTotalFare" value="3042" autocomplete="off"> -->
                  <div class="act_price">
                     {{hotel.Price.Currency}} {{hotel.Price.Amount | number:'1.1-2' }}
                  </div>
                  <!-- <span class="prntax">+ 326 Taxes &amp; fees</span> -->
                  <!-- <span class="prn">base price(Per Night)</span> -->
               </div>
            </div>
            <div class="checkincol js-sb">
               <div class="chktime" style="width: 100%;">
                <img src="assets/images/calendar_icon.svg">
                <span class="chktime">Check-In: </span>&nbsp; 
                <span class="blk">{{hotel.CheckIn}} </span>
            </div>
               <div class="chktime" style="width: 100%;">
                <img src="assets/images/calendar_icon.svg">
                <span class="chktime">Check-Out: </span>&nbsp; 
                <span class="blk">{{hotel.CheckOut}} </span>
            </div>
            </div>
            <!-- <div class="mt-3">
                <div class="row">
                    <div class="col-sm-4" style="color: #092e53;">Amenities:</div>
                    <div class="col-md-12 col-12 text-left amelist"
                    *ngIf="hotel.HotelAmenities && hotel.HotelAmenities.length > 0; else noAmenity">
                    <a   placement="top" tooltip="Parking" *ngIf="hasAmenities(hotel.HotelAmenities, 'Parking')"><i class="fas fa-parking cusromGrey"
                        >
                    </i> <span>Parking</span></a>
                    <a  placement="top" tooltip="Free toiletries" *ngIf="hasAmenities(hotel.HotelAmenities, 'Free toiletries')"><i class="fas fa-toilet cusromGrey" 
                        >
                    </i> <span>Free toiletries</span></a>

                   <a   placement="top" tooltip="TV" *ngIf="hasAmenities(hotel.HotelAmenities, 'TV')"> <i class="fa fa-tv cusromGrey" 
                        >
                    </i> <span>TV</span></a>
                    <a   placement="top" tooltip="Safe Toilet" *ngIf="hasAmenities(hotel.HotelAmenities, 'Safe Toilet')"> <i class="fa fa-toilet cusromGrey" 
                        >
                    </i> <span>Safe Toilet</span></a>
                    <a  placement="top" tooltip="Shower Towels" *ngIf="hasAmenities(hotel.HotelAmenities, 'Shower Towels')"> <i class="fa fa-shower cusromGrey" 
                        >
                    </i> <span>Shower Towels</span></a>
                    <a  placement="top" tooltip="Telephone" *ngIf="hasAmenities(hotel.HotelAmenities, 'Telephone')"><i class="fas fa-phone cusromGrey" tooltip="Telephone"
                        >
                    </i> <span>Telephone</span></a>
                    <a  placement="top" tooltip="Air conditioning" *ngIf="hasAmenities(hotel.HotelAmenities, 'Air conditioning')"><i class="fas fa-air-conditioner cusromGrey"
                        >
                    </i> <span>Air conditioning</span></a>
                    <a placement="top" tooltip="Attached bathroom" *ngIf="hasAmenities(hotel.HotelAmenities, 'Attached bathroom')"><i class="fas fa-bath cusromGrey" 
                        >
                    </i> <span>Attached bathroom</span></a>
                </div>
                    <ng-template #noAmenity>
                        <div class="col-md-8 text-left">
                            No Amenities Found
                        </div>
                    </ng-template>
                </div>
            </div> -->
            <div class="btnhcolnv2 ol d-flex js-sb fixbtn">
               <a class="ouline-btn" id="room" (click)="goTo('roomDetail')">Select Rooms</a>
            </div>
         </div>

        
    </div>
</div>

